import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { ColorPicker } from 'primereact/colorpicker';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { Component } from 'react';
import { TreeService } from './TreeService';

import { Checkbox } from 'primereact/checkbox';

import { Calendar } from 'primereact/calendar';
import { TabPanel, TabView } from 'primereact/tabview';
import { withTranslation } from 'react-i18next';
import LoadingPanel from '../LoadingPanel';

class OperationLayer extends Component {
    toastInfo = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            columns: [],
            inputData: {},
            columnType: {},
            isOpen: true,
            loading: false,
            sameLayerTypePointCheck: false,
            sameLayerTypeLineCheck: false,
            sameLayerTypeRegionCheck: false,
            childLayerTypeAllCheck: false,
            childLayerTypePointCheck: false,
            childLayerTypeLineCheck: false,
            childLayerTypeRegionCheck: false,
            childLayerTypeContainsCheck: false,
            pointDisable: false,
            lineDisable: false,
            regionDisable: false,
            color: 'ffffff',
            file: null,
            fileErrorMessage: null,
            iconBase64: null,
            isSelectedMarker: false,
            requiredFields: [],
            selectedLayerStructure: null,
            changeInputs: []
        };
    }

    componentDidMount = async () => {
        const { t } = this.props;

        await this.getTreeTableColumns();
        await this.getChildIntersectRule();
        await this.getRequiredFields();
        this.setState({ isOpen: true });

        if (this.props.newAddRightMenuGeometry) {
            if (this.props.selectedNode == null) {
                let allStructure = await TreeService.GetLayerStructure();

                if (this.props.layerProps.id == 0) {
                    let parentStructure = await TreeService.GetLayerStructureByParentId(0);
                    if (parentStructure.data.layerStructureGeomType !== 3) {
                        this.setState({ isOpen: false });
                        return this.toastInfo.current.show({
                            severity: 'info',
                            summary: t('operationLayer.toast_info'),
                            detail: t('operationLayer.toast_top_polygon_required')
                        });
                    }
                    this.setState({ selectedLayerStructure: parentStructure.data, layerName: parentStructure.data.name });
                } else {
                    let type = this.props.layerProps.layertype;
                    if (this.props.layerProps.children && this.props.layerProps.children.length > 0) {
                        type = type + 1;
                    }
                    let parentStructure = await TreeService.GetLayerStructureByParentId(type);
                    if (parentStructure.data.layerStructureGeomType !== 3) {
                        this.setState({ isOpen: false });
                        return this.toastInfo.current.show({
                            severity: 'info',
                            summary: t('operationLayer.toast_info'),
                            detail: t('operationLayer.toast_child_polygon_required')
                        });
                    }
                    this.setState({ selectedLayerStructure: parentStructure.data, layerName: parentStructure.data.name });
                }
            }
            return;
        } else if (this.props.selectedNode == null) {
            return;
        }
        this.toastInfo.current.show({
            severity: 'info',
            summary: t('operationLayer.toast_info'),
            detail: t('operationLayer.toast_layer_info_opened')
        });
        await this.getData();
        await this.getIntersectRuleData();
    };

    getRequiredFields = async () => {
        let result = await TreeService.GetStructureTreeRequireds(null);
        if (result.success) {
            this.setState({ requiredFields: result.data.filter(x => x.id === this.props.layerType) });

            //this.setState({ requiredFields: result.data });
        }
    }
    getTreeTableColumns = async () => {
        const { t } = this.props;

        try {
            if (this.props.isDraftMode) {
                const tableId = this.props.selectedTable.id;

                let _dataDraftColumns = await TreeService.getTreeNodesData(tableId);

                if (_dataDraftColumns.length < 1) {
                    this.toastInfo.current.show({
                        severity: 'info',
                        summary: t('operationLayer.toast_info'),
                        detail: t('operationLayer.toast_columns_not_fetched')
                    });
                    return;
                }

                this.setState({ columns: _dataDraftColumns });
                return;
            }

            let _data = await TreeService.getTreeNodesData();

            if (_data.length < 1) {
                this.toastInfo.current.show({
                    severity: 'info',
                    summary: t('operationLayer.toast_info'),
                    detail: t('operationLayer.toast_columns_not_fetched')
                });
                return;
            }

            this.setState({ columns: _data });
        } catch (e) {
            this.toastInfo.current.show({
                severity: 'info',
                summary: t('operationLayer.toast_info'),
                detail: t('operationLayer.toast_service_error')
            });
        }
    };


    getData = async () => {
        let _id = this.props.selectedNode.id;
        let data = { key: "id", value: _id.toString() };
        if (this.props.isDraftMode) {

            data._tableId = this.props.selectedTable.id;

        }

        let _data = await TreeService.queryTable(data);
        let _firstData = _data.data[0];
        let _inputData = {};

        this.state.columns.forEach(col => {
            _inputData[col.name] = _firstData[col.name]
        });

        this.setState({
            inputData: _inputData, color: !_firstData["backgroundcolor"] ? "ffffff" : _firstData["backgroundcolor"],
            iconBase64: _firstData["icon"],
            isSelectedMarker: _firstData["icon"] !== undefined && _firstData["icon"] !== ""
        });
    }

    getChildIntersectRule = async () => {

        if (!this.props.layerProps) {

            return;

        }

        try {
            this.setState({
                loading: true
            })

            let response;

            if (this.props.isDraftMode) {

                let tableId = this.props.selectedTable.id;

                response = await TreeService.GetChilIntersectRule(this.props.layerProps.id, tableId);

            } else {

                response = await TreeService.GetChilIntersectRule(this.props.layerProps.id);
            }


            if (!response.success) {

                return;

            }

            let data = response.data;

            if (!data) {
                return;
            }

            if (data.childLayerLine) {
                this.setState({
                    sameLayerTypeLineCheck: true,
                    lineDisable: true
                })
            }
            if (data.childLayerPoint) {
                this.setState({
                    sameLayerTypePointCheck: true,
                    pointDisable: true
                })
            }
            if (data.childLayerRegion) {
                this.setState({
                    sameLayerTypeRegionCheck: true,
                    regionDisable: true
                })
            }

        } catch (e) {

        } finally {
            this.setState({
                loading: false
            })
        }




    }

    getIntersectRuleData = async () => {

        let response;

        if (this.props.isDraftMode) {

            let tableId = this.props.selectedTable.id;

            response = await TreeService.GetChilIntersectRule(this.props.selectedNode.id, tableId);

        } else {
            response = await TreeService.GetChilIntersectRule(this.props.selectedNode.id);

        }
        if (!response.success) {
            return;
        }

        let data = response.data;
        if (!data) {
            return;
        }
        this.setState({
            sameLayerTypeLineCheck: data.sameLayerLine,
            sameLayerTypePointCheck: data.sameLayerPoint,
            sameLayerTypeRegionCheck: data.sameLayerRegion,
            childLayerTypeLineCheck: data.childLayerLine,
            childLayerTypePointCheck: data.childLayerPoint,
            childLayerTypeRegionCheck: data.childLayerRegion,
            childLayerTypeContainsCheck: data.childLayerContains,
            childLayerTypeAllCheck: data.childLayerAll
        });
    }

    closePage = () => {
        this.props.onHide();
        this.props.updateParentState(false);
    }

    updateLayer = async () => {
        const { t } = this.props;

        if (this.isRequiredFields()) {
            return this.toastInfo.current.show({
                severity: 'warn',
                summary: t('operationLayer.toast_info'),
                detail: t('operationLayer.toast_fill_required_fields'),
                life: 1000
            });
        }

        if (this.props.selectedNode == null) {
            await this.handleSave();
            return;
        }

        let dynamicObjectDtos = this.createDynamicObjectDtos();
        let filteredObjectDto = dynamicObjectDtos.filter(i => i.columnName !== 'parent_id' && i.columnName !== 'layertype');
        let intersectRule = this.createIntersectRule();

        let requestData = {
            id: this.props.selectedNode.id,
            dynamicObjectDtos: filteredObjectDto,
            intersectRule: intersectRule
        };

        if (this.props.isDraftMode) {
            requestData.tableId = this.props.selectedTable.id;
        }

        TreeService.updateLayer(requestData).then(res => {
            if (res.success) {
                this.toastInfo.current.show({
                    severity: 'info',
                    summary: t('operationLayer.toast_info'),
                    detail: t('operationLayer.toast_update_success')
                });
                this.closePage();
                this.props.getTreeData();
            } else {
                this.toastInfo.current.show({
                    severity: 'info',
                    summary: t('operationLayer.toast_info'),
                    detail: `${t('operationLayer.toast_update_failed')}\n${res.message}`
                });
            }
        });
    };


    createDynamicObjectDtos = () => {
        let dynamicObjectDtos = [];
        let keys = Object.keys(this.state.inputData);
        keys.forEach(key => {

            let value = this.state.inputData[key];
            let _columnType = this.state.columns.find(i => i.name === key).type;

            if (value && _columnType === "DateTime") {

                value = new Date(value).toLocaleDateString("tr-TR");

            }

            let createdObject = {
                columnName: key,
                columnValue: String(value),
                columnType: _columnType
            }
            dynamicObjectDtos.push(createdObject);
        });
        if (this.state.color) {
            dynamicObjectDtos.push({
                columnName: "backgroundcolor",
                columnValue: this.state.color ? this.state.color : "ffffff",
                columnType: "String"
            });
        }

        dynamicObjectDtos.push({
            columnName: "icon",
            columnValue: this.state.iconBase64 ? this.state.iconBase64 : "",
            columnType: "String"
        });

        return dynamicObjectDtos;
    }

    createIntersectRule = () => {
        return {
            sameLayerPoint: this.state.sameLayerTypePointCheck,
            sameLayerLine: this.state.sameLayerTypeLineCheck,
            sameLayerRegion: this.state.sameLayerTypeRegionCheck,
            childLayerAll: this.state.childLayerTypeAllCheck,
            childLayerPoint: this.state.childLayerTypePointCheck,
            childLayerLine: this.state.childLayerTypeLineCheck,
            childLayerRegion: this.state.childLayerTypeRegionCheck,
            childLayerContains: this.state.childLayerTypeContainsCheck
        }
    }
    isRequiredFields = () => {

        var inputDatas = [];

        if (!this.state.inputData["name"]) {

            inputDatas.push({ name: "name", value: null });

        }

        for (let i = 0; i < this.state.columns.length; i++) {

            let column = this.state.requiredFields.find(x => x.columnName === this.state.columns[i].name);
            if (column) {
                inputDatas.push({ name: column.columnName, value: this.state.inputData[column.columnName] });
            }
        }

        return inputDatas.find(x => (x.value == null || x.value === '' || x.value === undefined)) != null;
    }
    handleSave = async () => {
        const { t } = this.props;

        try {
            if (this.isRequiredFields()) {
                return this.toastInfo.current.show({ severity: 'warn', summary: 'Bilgi', detail: 'Zorunlu alanları doldurunuz', life: 1000 });
            }

            let dynamicObjectDtos = this.createDynamicObjectDtos();
            let parentId = this.props.layerProps === 0 ? 0 : this.getParentId();
            dynamicObjectDtos.push(this.createParentIdObject(parentId));

            if (!this.props.isExistLayer && !this.props.newAddRightMenuGeometry) {
                let insertLayerStructure = await this.checkAndInsertLayerStructure(this.props.layerType, this.props.layerProps.layertype);
                if (!insertLayerStructure) {
                    this.toastInfo.current.show({
                        severity: 'warn',
                        summary: t('operationLayer.toast_info'),
                        detail: t('operationLayer.toast_layer_type_add_failed'),
                        life: 3000
                    });
                    return;
                }
            }

            if (this.props.newAddRightMenuGeometry) {
                let geometryObject = this.createGeometryObject();
                dynamicObjectDtos.push(geometryObject);
            }

            let childrenLayerType = (this.props.layerProps.children && this.props.layerProps.children.length > 0)
                ? this.props.layerProps.children[0].layertype
                : this.props.layerProps.layertype;

            if (this.state.selectedLayerStructure) {
                dynamicObjectDtos.push({
                    columnName: "layertype",
                    columnValue: this.state.selectedLayerStructure.layerId.toString(),
                    columnType: "Int32"
                });
            } else {
                dynamicObjectDtos.push(this.createLayerTypeObject());
            }

            this.setState({ loading: true });
            await this.addNewLayer(dynamicObjectDtos);

        } catch (e) {
            this.toastInfo.current.show({
                severity: 'error',
                summary: t('operationLayer.toast_info'),
                detail: t('operationLayer.toast_add_failed'),
                life: 3000
            });
        }
    };


    createParentIdObject = (parentId) => {
        return {
            columnName: "parent_id",
            columnValue: String(parentId),
            columnType: "Int64"
        }
    }

    createLayerTypeObject = () => {
        return {
            columnName: "layertype",
            columnValue: this.props.layerType ? String(this.props.layerType) : String(this.props.layerProps.layertype),
            columnType: "Int32"
        }
    }

    createGeometryObject = () => {
        let feature = this.props.newAddRightMenuGeometry;
        let geometry = feature.getGeometry();
        let geometryType = geometry.getType();
        let coordinates = geometry.getCoordinates();
        return {
            columnName: "geoloc",
            columnType: "Geometry",
            columnValue: JSON.stringify({ type: geometryType, coordinates: coordinates })
        }
    }

    checkAndInsertLayerStructure = async (layerId, parentId) => {
        try {
            let data = { layerId, parentId, name: 'İsimsiz' };
            if (layerId === 0) {
                data.layerId = 1;
                data.parentId = 0;
            }
            let response = await TreeService.InsertLayerStructure(data);
            return response.success;
        } catch (e) {
            return false;
        }
    }

    addNewLayer = async (dynamicObjectDtos) => {
        const { t } = this.props;

        let intersectRule = this.createIntersectRule();

        let requestData = { dynamicObjectDtos: dynamicObjectDtos, intersectRule: intersectRule };

        if (this.props.isDraftMode) {
            requestData.tableId = this.props.selectedTable.id;
        }

        let _findName = dynamicObjectDtos.find(i => i.columnName == "name").columnValue;

        let _existLayerRequestDate = {
            key: 'name',
            value: _findName
        };

        if (this.props.isDraftMode) {
            _existLayerRequestDate.tableId = this.props.selectedTable.id;
        }

        let _resExistLayer = await TreeService.queryTable(_existLayerRequestDate);

        if (_resExistLayer.success && _resExistLayer.data && !_resExistLayer.data[0].is_deleted) {
            this.setState({ loading: false });
            this.props.thisToast.current.show({
                severity: 'warn',
                summary: t('operationLayer.toast_info'),
                detail: t('operationLayer.toast_layer_exists'),
                life: 3000
            });
            return;
        }

        let res = await TreeService.addNewLayer(requestData);

        this.setState({ loading: false });

        if (res && res.success) {
            if (this.props.thisToast) {
                this.props.thisToast.current.show({
                    severity: 'info',
                    summary: t('operationLayer.toast_info'),
                    detail: t('operationLayer.toast_add_success'),
                    life: 3000
                });
            }

            if (!this.props.newAddRightMenuGeometry) {
                if (this.props.isDraftMode) {
                    this.props.getDraftTree(this.props.selectedTable.id);
                } else {
                    this.props.getTree();
                }
            }

            if (this.props.newAddRightMenuGeometry) {
                this.props.updateParentState(true);
            }

            this.dialogCloseHandle();
        } else {
            this.setState({ loading: false });
            this.props.thisToast.current.show({
                severity: 'error',
                summary: t('operationLayer.toast_info'),
                detail: t('operationLayer.toast_add_failed') + '\n' + res.message,
                life: 3000
            });
        }
    };


    getParentId = () => this.props.layerProps.id;

    dialogCloseHandle = () => {
        this.setState({ inputData: {}, columnType: {} });
        this.props.onHide();
        this.props.updateParentState(false);
    }

    handleInputChange = (columnName, type, value) => {

        this.setState((prevState) => ({
            inputData: { ...prevState.inputData, [columnName]: value },
            columnType: { ...prevState.columnType, [columnName]: type },
            changeInputs: [Math.random() * 100]
        }));
    }

    handleSwitchChange = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({ [name]: value });
    }

    renderFormInputs = () => {
        const { columns, inputData, changeInputs } = this.state;
        if (!columns) return null;
        return columns.map((column) => {
            const { name, type, displayName, isRequired } = column;
            if (name === "parent_id" || name === "layertype") return null;
            return (
                <div class="field" key={name}>
                    <label htmlFor={name}>{name === "name" ? "isim" : (displayName === null ? name : displayName)}</label>
                    {this.renderInputElement(name, type, inputData[name], this.state.requiredFields.find(x => x.columnName === name) != null)}
                </div>




            );
        });
    }

    renderInputElement = (name, type, value, isRequired) => {
        switch (type) {
            case "String":
                return <>{
                    isRequired && isRequired === true && <span>(*)</span>} <InputText style={(!value && isRequired || (!value && name == "name")) ? { border: '2px solid red' } : {}} className=" w-full" invalid={!value && (isRequired && isRequired === true)} variant="filled" key={name} value={value}
                        onChange={(e) => this.handleInputChange(name, type, e.target.value, isRequired)} /> </>;
            case "Boolean":
                return <InputSwitch key={name} checked={value} onChange={(e) => this.handleInputChange(name, type, e.value)} />;
            case "Double":
            case "Int64":
            case "Int32":
                return <InputNumber key={name} value={value} onChange={(e) => this.handleInputChange(name, type, e.value)} />;
            case "DateTime":
                return <Calendar
                    key={name}
                    value={new Date(value)} // Ensure value is a Date object
                    onChange={(e) => {
                        const formattedDate = new Date(e.value);
                        this.handleInputChange(name, type, formattedDate)
                    }}
                    format="dd/mm/yy"
                    locale="tr"
                    showIcon
                    placeholder="gg/aa/yyyy"
                />
            default:
                return null;
        }
    }

    footer = () => {
        const { t } = this.props;

        return (
            <div>
                <Button
                    label={t("addLayerPanel.button_save")}
                    icon="pi pi-check"
                    onClick={this.updateLayer}
                />
                <Button
                    label={t("addLayerPanel.button_close")}
                    severity="secondary"
                    icon="pi pi-times"
                    style={{ marginLeft: '0.5em' }}
                    onClick={this.closePage}
                />
            </div>
        );
    };


    handleFileChange = (e) => {
        const { t } = this.props;

        const selectedFile = e.target.files[0];

        if (selectedFile) {
            const img = new Image();
            img.src = URL.createObjectURL(selectedFile);
            img.onload = () => {
                if ((img.width === 16 && img.height === 16) || (img.width === 32 && img.height === 32)) {
                    this.convertToBase64(selectedFile);
                    this.setState({
                        file: selectedFile,
                        fileErrorMessage: t('operationLayer.toast_file_uploadable')
                    });
                } else {
                    this.setState({
                        file: null,
                        fileErrorMessage: t('operationLayer.toast_file_invalid_size')
                    });
                }
            };
        }
    };

    convertToBase64 = (file) => {
        const { t } = this.props;

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({ file: file, iconBase64: reader.result });
        };
        reader.onerror = (error) => {
            console.error("Base64 conversion error:", error);
            this.setState({ fileErrorMessage: t('operationLayer.toast_file_read_error') });
        };
    };

    handleFileUpload = () => {
        if (this.file && this.base64) {

            this.setState({ file: null, iconBase64: null });
        }
    }
    render() {
        const { loading } = this.state;
        const { layerName, t } = this.props;
        if (loading) {


            return (<>
                <Toast ref={this.toastInfo} />
                <div id="blur">
                    <LoadingPanel className="tree-loading-panel" />
                </div>
            </>

            )




        }
        return (
            <>
                <Toast ref={this.toastInfo} />
                <Dialog style={{ width: '500px' }} visible={this.state.isOpen} header={layerName ? `${t('operationLayer.layer_type')}: ${layerName}` : t('operationLayer.layer_info')}
                    modal footer={this.footer} onHide={this.dialogCloseHandle}>

                    <TabView>
                        <TabPanel header={t('operationLayer.general_info')}>
                            {(this.state.columns.length < 1 && this.state.inputData) && <>
                                <Skeleton className="mb-2"></Skeleton>
                                <Skeleton width="10rem" className="mb-2"></Skeleton>
                                <Skeleton width="5rem" className="mb-2"></Skeleton>
                                <Skeleton height="2rem" className="mb-2"></Skeleton>
                                <Skeleton width="10rem" height="4rem"></Skeleton>
                            </>}
                            {this.renderFormInputs()}
                        </TabPanel>
                        <TabPanel header={t('operationLayer.intersect_rules')}>

                            <Accordion expand style={{ width: 'auto' }}>
                                {this.renderAccordionTab(t('operationLayer.same_level_intersect'), [
                                    { label: t('operationLayer.disable_point'), checked: this.state.sameLayerTypePointCheck, name: "sameLayerTypePointCheck", disabled: this.state.pointDisable },
                                    { label: t('operationLayer.disable_line'), checked: this.state.sameLayerTypeLineCheck, name: "sameLayerTypeLineCheck", disabled: this.state.lineDisable },
                                    { label: t('operationLayer.disable_polygon'), checked: this.state.sameLayerTypeRegionCheck, name: "sameLayerTypeRegionCheck", disabled: this.state.regionDisable }
                                ])}
                                {this.renderAccordionTab(t('operationLayer.child_area_intersect'), [
                                    { label: t('operationLayer.disable_point'), checked: this.state.childLayerTypePointCheck, name: "childLayerTypePointCheck" },
                                    { label: t('operationLayer.disable_line'), checked: this.state.childLayerTypeLineCheck, name: "childLayerTypeLineCheck" },
                                    { label: t('operationLayer.disable_polygon'), checked: this.state.childLayerTypeRegionCheck, name: "childLayerTypeRegionCheck" },
                                    { label: t('operationLayer.contains_sub_layers'), checked: this.state.childLayerTypeContainsCheck, name: "childLayerTypeContainsCheck" }
                                ])}
                            </Accordion>

                        </TabPanel>
                        <TabPanel header={t('operationLayer.style_operations')}>
                            <div className="flex flex-wrap align-items-center mb-3 gap-2" >

                                <label>{t('operationLayer.select_layer_color')}</label>
                                <ColorPicker style={{ width: '100px' }} format="hex" value={this.state.color} onChange={(e) => this.setState({ color: e.value })} />
                            </div>
                            <br />
                            <div className="flex align-items-center">
                                <Checkbox inputId="ingredient1" name="isMarker" onChange={(e) => {
                                    this.setState({ isSelectedMarker: e.checked });
                                    if (e.checked) {
                                        this.setState({ iconBase64: process.env.PUBLIC_URL + "/marker.png" });
                                    }
                                    else {
                                        this.setState({ iconBase64: null });
                                    }
                                }} checked={this.state.isSelectedMarker} />
                                <label htmlFor="ingredient1" className="ml-2">{t('operationLayer.select_marker')}</label>

                            </div>
                            <br />
                            {this.state.isSelectedMarker && <div tooltip={t('operationLayer.tooltip_point_layer')} className="flex flex-wrap align-items-center mb-3 gap-2" >
                                <label>İcon   </label>
                                <div>
                                    <label for="file-upload" class="custom-file-upload">
                                        {t('operationLayer.select')}
                                    </label>
                                    <input style={{ display: "none" }} id="file-upload" type="file" onChange={this.handleFileChange} accept="image/*" />

                                    {this.file && (
                                        <div>
                                            <p>{t('operationLayer.selected_file')}: {this.state.file.name}</p>

                                            <button onClick={this.handleFileUpload}>{t('operationLayer.upload_file')}</button>

                                        </div>
                                    )}
                                </div>



                                <img src={this.state.iconBase64 ? this.state.iconBase64 : process.env.PUBLIC_URL + "/marker.png"} height="32" />
                                <Button onClick={() => {
                                    this.setState({ iconBase64: null, fileErrorMessage: '', isSelectedMarker: false })

                                }} label={t('operationLayer.remove')} severity="danger"></Button>
                                <br />
                                <br />
                                <span style={{ color: this.state.file ? "green" : "red" }}>{this.state.fileErrorMessage}</span>
                            </div>}
                        </TabPanel>

                    </TabView>


                </Dialog>
            </>
        );
    }

    renderAccordionTab = (header, items) => (
        <AccordionTab header={header}>
            {items.map(item => (
                <div style={{ display: 'flex', width: '100%', marginBottom: "10px" }} key={item.name}>
                    <div style={{ width: '30%' }}>
                        <label>{item.label}</label>
                    </div>
                    <div style={{ width: '70%' }}>
                        <InputSwitch checked={item.checked} name={item.name} onChange={this.handleSwitchChange} disabled={item.disabled} />
                    </div>
                </div>
            ))}
        </AccordionTab>
    );
}

export default withTranslation()(OperationLayer);
